
import { defineComponent, reactive } from 'vue';
import route from '@/router';
import store from '@/store';

import { deleteById, get, put } from '@/utils/api';
import cookie from '@/utils/cookie';
import { checkNewToken, checkTokenExists } from '@/utils/token';
import User from '@/models/User';
import HeaderLinks from '../components/HeaderLinks.vue';
import InputField from '../components/InputField.vue';
import Button from '../components/Button.vue';

type State = {
	user: User;
	username: string;
	saveButtonText: string;
	deletingUser: Boolean;

	error: string;
	loading: Boolean;
};

export default defineComponent({
	components: {
		HeaderLinks,
		InputField,
		Button,
	},

	setup() {
		const state: State = reactive({
			user: {
				id: '',
				firstName: '',
				lastName: '',
				username: '',
				email: '',
				password: '',
			},
			username: '',
			saveButtonText: 'Save',
			deletingUser: false,

			error: '',
			loading: false,
		});

		const getData = async () => {
			const token = cookie.get('token');

			if (token) {
				const userId = store.getters.getUserId();

				const timeout = setTimeout(() => {
					state.loading = true;
				}, 1000);
				const data = await get(`user/${userId}`, token);
				clearTimeout(timeout);
				state.loading = false;

				if (data.error) {
					state.error = data.message;
					return;
				}

				checkTokenExists(data.statusCode, route);

				const newToken = checkNewToken(data);
				if (newToken) {
					await getData();

					return;
				}

				if (data.user) {
					state.user = data.user;
					state.username = data.user.username;
				}
			} else {
				route.replace('/login');
			}
		};

		const updateUser = async (event: Event) => {
			event.preventDefault();

			const token = cookie.get('token');

			if (token) {
				const data = await put('user', state.user.id, state.user, token);

				checkTokenExists(data.statusCode, route);

				const newToken = checkNewToken(data);
				if (newToken && state.user.username == state.username) {
					await updateUser(event);

					return;
				}

				if (data.statusCode == 'OK') {
					state.saveButtonText = 'Data saved!';
				} else if (data.statusCode == 'DUPLICATE_USER') {
					state.error = 'That username or email is already in use.';
				}
			} else {
				route.replace('/login');
			}
		};

		const toggleDeleting = () => {
			state.deletingUser = !state.deletingUser;
		};

		const deleteUser = async () => {
			if (state.deletingUser) {
				const token = cookie.get('token');

				if (token) {
					const data = await deleteById('user', state.user.id, token);

					checkTokenExists(data.statusCode, route);

					const newToken = checkNewToken(data);
					if (newToken) {
						await deleteUser();

						return;
					}

					cookie.delete('token');

					route.replace('/');
				} else {
					route.replace('/login');
				}
			}
		};

		getData();

		return {
			state,

			updateUser,
			toggleDeleting,
			deleteUser,
		};
	},
});
